export default __webpack_public_path__ + "static/media/karan.png.webp";